import type { Tool } from './types';

export const nakshatraCalculator: Tool = {
  slug: 'nakshatra-calculator',
  metaTitle: 'Nakshatra Calculator — Find Your Birth Star by Date of Birth',
  metaDescription:
    'Free Nakshatra calculator. Find your janma nakshatra (birth star), its pada, ruling planet and deity from your date, time and place of birth — with an AI explanation of what it means.',
  keywords:
    'nakshatra calculator, birth star calculator, janma nakshatra, nakshatra by date of birth, nakshatra finder, my nakshatra, birth nakshatra and pada, nakshatra lord',
  eyebrow: 'Birth Star',
  h1: 'Nakshatra Calculator (Birth Star Finder)',
  appName: 'KundaliAI Nakshatra Calculator',
  calculator: 'nakshatra',
  intro:
    'Find your janma nakshatra — the lunar mansion the Moon occupied at your birth — along with its pada (quarter), ruling planet and deity. KundaliAI computes it from precise sidereal positions using your date, time and place of birth, then explains in plain language what your nakshatra says about your temperament, relationships and Vimshottari dasha sequence. Free to start.',
  ctaLabel: 'Find my Nakshatra free',
  ctaHref: '/chat',
  sections: [
    {
      heading: 'What is a nakshatra?',
      body: 'The sidereal zodiac is divided into **27 nakshatras** (lunar mansions) of 13°20′ each, from Ashwini to Revati. Your **janma nakshatra** is the one occupied by the Moon at the moment of your birth. It is one of the most personal points in Jyotish: it sets your **Vimshottari dasha** starting period, names your mind\'s ruling deity and planet, and drives nakshatra-based **kundli matching (Ashtakoot)**. Each nakshatra is further split into four **padas** that refine the reading.',
    },
    {
      heading: 'How the calculator works',
      body: "KundaliAI computes the Moon's exact sidereal longitude (Lahiri ayanamsa) for your birth moment using astronomical-grade VSOP87 ephemeris data, with the timezone derived from your birthplace — the same method used for printed panchangs. Because the Moon moves roughly **13° per day**, it can change nakshatra within hours, which is why the **time of birth matters**. The result includes your nakshatra, pada, ruling planet (dasha lord) and symbol.",
    },
    {
      heading: 'What your nakshatra tells you',
      body: 'Your nakshatra shapes how a Jyotishi reads your Moon: instinctive nature, emotional style, compatible birth stars, and auspicious naming syllables for newborns. It also fixes where your **Vimshottari mahadasha** cycle begins — ask the AI astrologer to walk through your current dasha once you have your nakshatra. If your birth time is approximate, KundaliAI flags whether you fall near a nakshatra boundary.',
    },
  ],
  faq: [
    {
      question: 'How do I find my nakshatra by date of birth?',
      answer:
        'Enter your date, time and place of birth. The calculator computes the Moon\'s sidereal position for that exact moment and returns your nakshatra and pada. Date alone is often not enough, because the Moon can change nakshatra during a single day.',
    },
    {
      question: 'What is a nakshatra pada?',
      answer:
        'Each nakshatra spans 13°20′ and is divided into four padas of 3°20′ each. The pada refines the reading — it maps your nakshatra into a navamsa (D9) sign and is used for naming syllables and finer compatibility analysis.',
    },
    {
      question: 'Which ayanamsa does this calculator use?',
      answer:
        'KundaliAI uses the Lahiri (Chitrapaksha) ayanamsa, the standard used by most Indian panchangs and government ephemerides, so results align with what a traditional Jyotishi or printed panchang would give.',
    },
    {
      question: 'Why does my nakshatra matter for dasha and matching?',
      answer:
        'Your janma nakshatra determines the starting mahadasha of your Vimshottari cycle and is the basis of several Ashtakoot matching kootas (including the 8-point Nadi). That is why kundli matching is traditionally done from the bride and groom\'s birth stars.',
    },
  ],
  related: [
    { label: 'Free Kundli by date of birth', href: '/free-kundli' },
    { label: 'Dasha calculator (Vimshottari)', href: '/dasha-calculator' },
    { label: 'Lagna / ascendant calculator', href: '/lagna-calculator' },
    { label: 'Talk to an AI astrologer', href: '/ai-astrologer' },
  ],
};
